<template>
    <div id="ff-cash">
        <div class="card card-custom">
            <div class="card-body p-0">
                <div class="1py-8 px-8 py-lg-20 px-lg-10">
                    <h4 style="text-align: end">Opening date: {{ new Date(dateBox) }}</h4>
                    <h5 style="text-align: end">Clinic: {{ facilityName }}</h5>
                    <hr />
                    <b-container>
                        <b-row>
                            <b-col>
                                <b-table :fields="fields" :items="[1]">
                                    <template #cell(total_patients)>
                                        {{ totalPatients }}
                                    </template>
                                    <template #cell(total_cash)>
                                        $ {{ current_balance }}
                                    </template>
                                    <template #cell(total_credit_cash)>
                                        $ {{ total_credit_cash }}
                                    </template>
                                    <template #cell(total_income)> $ {{ income }} </template>
                                </b-table>
                                <DayTotalsReference class="mt-3" :dayTotals="resolvedDayTotals" />
                                <hr />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-table :fields="fieldsData" :items="[1]">
                                    <template #cell(frontdesks)>
                                        <ul>
                                            <li v-for="cash in cashes">
                                                {{ cash.frontdesks.name }}
                                                {{ cash.frontdesks.lastname }}
                                            </li>
                                        </ul>
                                    </template>
                                    <template #cell(references)>
                                        <ul>
                                            <li v-for="redes in optionsR.labels">
                                                {{ redes }}
                                            </li>
                                            <li>Total References: {{ totalPatients }}</li>
                                        </ul>
                                    </template>
                                    <template #cell(type_visits)>
                                        <ul>
                                            <li v-for="typeVisit in optionsTV.labels">
                                                {{ typeVisit }}
                                            </li>
                                            <li>
                                                Total visits:
                                                {{ totalPatients }}
                                            </li>
                                        </ul>
                                    </template>
                                </b-table>
                                <hr />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div v-for="cash in cashes">
                                    <b-row>
                                        <b-col md="1">
                                            <b-avatar size="48" :src="cash.frontdesks.avatar" />
                                        </b-col>
                                        <b-col md="5" align-self="center">
                                            <h1>
                                                {{ cash.frontdesks.name }}
                                                {{ cash.frontdesks.lastname }} - ${{ cash.income }}
                                            </h1>
                                        </b-col>
                                    </b-row>
                                    <hr />
                                    <b-table small hover :fields="fieldsTable" :items="cash.movements" responsive show-empty
                                        empty-text="No matching records found">
                                        <template #cell(patient)="data">
                                            <div class="list-unstyled my-2 facility"
                                                style="word-wrap: break-word; overflow: hidden" v-if="patientOf(data.item)">
                                                <p>
                                                    <span style="word-wrap: break-word; overflow: hidden">
                                                        {{ patientOf(data.item).name }}
                                                        {{ patientOf(data.item).lastname }}
                                                    </span>
                                                </p>
                                            </div>
                                            <span v-else>N/A</span>
                                        </template>
                                        <template #cell(diagnostic_imagings)="data">
                                            <div class="list-unstyled my-2 facility"
                                                style="word-wrap: break-word; overflow: hidden"
                                                v-if="officeVisitItems(data.item, 'diagnostic_imagings').length">
                                                <p v-for="(item, i) in officeVisitItems(data.item, 'diagnostic_imagings')" :key="i">
                                                    <span style="word-wrap: break-word; overflow: hidden">{{ item.name }}</span>
                                                </p>
                                            </div>
                                            <span v-else>N/A</span>
                                        </template>
                                        <template #cell(package)="data">
                                            <div class="list-unstyled my-2 facility">
                                                <div variant="info" v-if="officeVisitPackage(data.item)">
                                                    <span>{{ officeVisitPackage(data.item).name }}</span>
                                                </div>
                                                <span v-else>N/A</span>
                                            </div>
                                        </template>
                                        <template #cell(iv_serums)="data">
                                            <div class="list-unstyled my-2 facility" v-if="officeVisitSerums(data.item).length">
                                                <p v-for="serum in officeVisitSerums(data.item)" :key="serum.id">
                                                    <span>{{ serum.package ? serum.package.name : 'IV serum' }} — ${{ serumPrice(serum) }}</span>
                                                </p>
                                            </div>
                                            <span v-else>N/A</span>
                                        </template>
                                        <template #cell(laboratories)="data">
                                            <div class="list-unstyled my-2 facility"
                                                v-if="officeVisitItems(data.item, 'laboratories').length">
                                                <p v-for="(item, i) in officeVisitItems(data.item, 'laboratories')" :key="i">
                                                    <span>{{ item.name }}</span>
                                                </p>
                                            </div>
                                            <span v-else>N/A</span>
                                        </template>
                                        <template #cell(procedures)="data">
                                            <div class="list-unstyled my-2 facility"
                                                v-if="officeVisitItems(data.item, 'procedures').length">
                                                <p v-for="(item, i) in officeVisitItems(data.item, 'procedures')" :key="i">
                                                    <span>{{ item.name }}</span>
                                                </p>
                                            </div>
                                            <span v-else>N/A</span>
                                        </template>
                                        <template #cell(tests)="data">
                                            <div class="list-unstyled my-2 facility"
                                                v-if="officeVisitItems(data.item, 'tests').length">
                                                <p v-for="(item, i) in officeVisitItems(data.item, 'tests')" :key="i">
                                                    <span>{{ item.name }}</span>
                                                </p>
                                            </div>
                                            <span v-else>N/A</span>
                                        </template>
                                        <template #cell(treatments)="data">
                                            <div class="list-unstyled my-2 facility"
                                                v-if="officeVisitItems(data.item, 'treatments').length">
                                                <p v-for="(item, i) in officeVisitItems(data.item, 'treatments')" :key="i">
                                                    <span>{{ item.name }}:
                                                        {{ treatmentCant(item) }}</span>
                                                </p>
                                            </div>
                                            <span v-else>N/A</span>
                                        </template>
                                        <template #cell(total)="data">
                                            <span>${{ getTotal(data.item.appointment) }}</span>
                                        </template>
                                    </b-table>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <hr />
                                <h4>Observation: {{ observation }}</h4>
                                <hr />
                                <div class="cardSign">
                                    <img :src="photoUrl" />
                                    <h5>Sign</h5>
                                </div>
                                <hr />
                                <b-button class="boton" variant="outline-primary" @click="sendData">
                                    Print
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
                <ToastNotification ref="toast" />
            </div>
        </div>
        <ToastNotification ref="toast" />
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
} from "bootstrap-vue";

import ToastNotification from "@/components/ToastNotification";
import diagnostics from "./components/diagnostics.vue";
import DayTotalsReference from "./components/DayTotalsReference.vue";
import VueApexCharts from "vue-apexcharts";
import NotificationMixin from "@/mixins/NotificationMixin";
import axiosC from "@/core/services/api/cash-account";
import axiosEC from "@/core/services/api/external-settings/cloudinary";
import html2pdf from "html2pdf.js";
import { summarizeCashClosingCharts } from "@/core/utils/typeVisitsChart";
import { ivSerumLines, ivSerumPrice, shouldShowPackage } from "@/core/utils/ivTherapies";

export default {
    components: {
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BButton,
        BFormInvalidFeedback,
        VueApexCharts,
        diagnostics,
        ToastNotification,
        DayTotalsReference,
    },
    mixins: [NotificationMixin],
    props: {
        dayTotals: {
            type: Object,
            default: null,
        },
    },
    mounted() {
        this.dailyData = this.$store.state.closingCash;
    },
    computed: {
        resolvedDayTotals() {
            if (this.dayTotals) return this.dayTotals
            return (this.dailyData && this.dailyData.dayTotals) || null
        },
    },
    watch: {
        dailyData: {
            immediate: true,
            handler() {
                this.applyDailyData();
            },
        },
    },
    data() {
        return {
            observation: "",
            photoUrl: "",
            facilityName: "",
            cashes: [],
            dailyData: null,
            dateBox: "",
            optionsTV: {
                labels: ["F/U: 0", "N/C: 0", "N/P: 0", "P/I: 0", "P/P: 0", "R/S: 0", "V/C: 0", "M/B: 0", "N/A: 0"],
                dataLabels: {
                    enabled: true,
                },
            },
            optionsR: {
                labels: [
                    "Radio: 0",
                    "TV: 0",
                    "Facebook: 0",
                    "Reference: 0",
                    "Sign: 0",
                    "Flyers: 0",
                    "Internet: 0",
                    "Others: 0",
                ],
                dataLabels: {
                    enabled: true,
                },
            },
            fields: [
                "total_patients",
                "total_credit_cash",
                "total_cash",
                "total_income",
            ],
            fieldsData: ["frontdesks", "references", "type_visits"],
            fieldsTable: [
                { key: "patient", label: "Patient" },
                { key: "package", label: "Package" },
                { key: "iv_serums", label: "IV Serums" },
                { key: "diagnostic_imagings", label: "Diagnostic imagings" },
                { key: "laboratories", label: "Laboratories" },
                { key: "procedures", label: "Procedures" },
                { key: "tests", label: "Tests" },
                { key: "treatments", label: "Treatments" },
                { key: "total", label: "Total" },
            ],
            totalPatients: 0,
            current_balance: 0,
            income: 0,
            total_credit_cash: 0,
            seriesTV: [0, 0, 0, 0, 0, 0, 0, 0, 0],
            seriesR: [0, 0, 0, 0, 0, 0, 0, 0],
        };
    },
    methods: {
        applyDailyData() {
            const daily = this.dailyData;
            if (!daily) return;
            this.dateBox = daily.opening;
            this.cashes = daily.cashes || [];
            this.facilityName = (daily.facilities && daily.facilities.name) || "";
            this.photoUrl = daily.photoUrl;
            this.observation = daily.observation;
            this.current_balance = daily.current_balance || 0;
            this.income = daily.income || 0;

            const summary = summarizeCashClosingCharts(this.cashes);
            this.totalPatients = summary.totalPatients;
            this.seriesTV = summary.seriesTV;
            this.seriesR = summary.seriesR;
            this.optionsTV = {
                ...this.optionsTV,
                labels: summary.labelsTV,
            };
            this.optionsR = {
                ...this.optionsR,
                labels: summary.labelsR,
            };

            let total_credit_cash = 0;
            this.cashes.forEach((box) => {
                ((box && box.movements) || []).forEach((movement) => {
                    const appointment = movement && movement.appointment;
                    total_credit_cash += appointment && appointment.cc ? appointment.cc : 0;
                });
            });
            this.total_credit_cash = total_credit_cash;
        },
        patientOf(movement) {
            return (movement && movement.appointment && movement.appointment.patients) || null;
        },
        officeVisitOf(movement) {
            return (movement && movement.appointment && movement.appointment.office_visit) || null;
        },
        officeVisitItems(movement, key) {
            const visit = this.officeVisitOf(movement);
            const items = visit && visit[key];
            return Array.isArray(items) ? items : [];
        },
        officeVisitPackage(movement) {
            const visit = this.officeVisitOf(movement);
            const pack = (visit && visit.package) || null;
            return shouldShowPackage(pack, ivSerumLines(visit)) ? pack : null;
        },
        officeVisitSerums(movement) {
            return ivSerumLines(this.officeVisitOf(movement));
        },
        serumPrice(serum) {
            return ivSerumPrice(serum).toFixed(2);
        },
        treatmentCant(item) {
            return item && item.pivot && item.pivot.cant ? item.pivot.cant : 1;
        },
        getTotal(appointment) {
            if (appointment) return ((appointment.cash != null ? appointment.cash : 0) + (appointment.cc != null ? appointment.cc : 0))
            return 0
        },
        desdePadre() {
            return this.descargarArchivoEnPdf()
        },
        async descargarArchivoEnPdf() {
            await this.$nextTick()
            var element = document.getElementById("ff-cash");
            const clonedElement = element.cloneNode(true);
            const divsNoImprimir = clonedElement.getElementsByClassName("boton");
            while (divsNoImprimir.length > 0) {
                divsNoImprimir[0].parentNode.removeChild(divsNoImprimir[0]);
            }
            html2pdf().from(clonedElement).save();
            const options = {
                output: "blob",
            };
            let url = ''
            return html2pdf()
                .set(options)
                .from(clonedElement)
                .toPdf()
                .output("blob")
                .then(async (pdfBlob) => {
                    const formData = new FormData();
                    formData.append("file", pdfBlob, "nombre_del_archivo.pdf");
                    const { secure_url } = await axiosEC.createImage(formData);
                    await this.$emit('attach', `${this.dailyData.urlFile}, ${secure_url}`)
                    return `${this.dailyData.urlFile}, ${secure_url}`
                });
        },
        async sendData() {
            //   const data = {
            //     attach: `${this.dailyData.urlFile}, ${url}`,
            //     cash_id: this.dailyData.id,
            //   };
            //   axiosC.attachFile(data).then(() => {
            new Promise((resolve, reject) => {
                resolve(true);
                window.print();
            }).then(() => this.$router.push({ name: "dashboard" }));
            //   });
        },
        async uploadPhoto(file) {
            const formData = new FormData();
            formData.append("file", file);
            const { secure_url } = await axiosEC.createImage(formData);
            return secure_url;
        },
    },
};
</script>
<style lang="scss">
.cardSign {
    border-radius: 15px;
    border: 1px solid #e5e5e5;
    margin: 1%;
    padding: 1%;
}

@media print {
    .boton {
        display: none;
    }
}
</style>
